import { render, staticRenderFns } from "./Riwayat.vue?vue&type=template&id=1a42c610&"
import script from "./Riwayat.vue?vue&type=script&lang=js&"
export * from "./Riwayat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports